import moment from "moment";

const ANTTags2 = (doc, data) => {
    console.log("ANTTags2", data);
    
    
    //ETIQUETA PADRE
    var ANT = doc.createElement("ANT");

     //Valor del anticipo  No puede ser superior al valor total de la factura (TOT_1)
     var ANT_1 = doc.createElement("ANT_1");
     ANT_1.innerHTML = parseInt(data.totalCopagos);
     ANT.appendChild(ANT_1);

     //Moneda del valor del anticipo
     var ANT_2 = doc.createElement("ANT_2");
     ANT_2.innerHTML = "COP";;
     ANT.appendChild(ANT_2);

     //Fecha en que se pagó el anticipo Formato AAAA-MM-DD 
     var ANT_3 = doc.createElement("ANT_3");
     ANT_3.innerHTML = moment(data.emision).format("YYYY-MM-DD"); 
     ANT.appendChild(ANT_3);

     //Hora en que se pagó el anticipo. Formato: HH:MM:SSdhh:mm,
     var ANT_4 = doc.createElement("ANT_4");
     ANT_4.innerHTML = moment(data.emision).utc().format("HH:mm:ss");
     ANT.appendChild(ANT_4);

     //Identificación del pago 
     var ANT_5 = doc.createElement("ANT_5");
     //ANT_5.innerHTML = !!item.tipo_pago ? item.tipo_pago : "COPAGO";
	 ANT_5.innerHTML = "1";
     ANT.appendChild(ANT_5);

     //Fecha en la cual el pago fue recibido. Formato: AAAA-MM-DD
     var ANT_6 = doc.createElement("ANT_6");
     ANT_6.innerHTML = moment(data.emision).format("YYYY-MM-DD");
     ANT.appendChild(ANT_6);

    //Instrucciones relativas al pago
     var ANT_7 = doc.createElement("ANT_7");
     switch (data.facturado.detallesPagoContrato.regimenContrato) {
        case 1:
            ANT_7.innerHTML = "NO APLICA";
            break;
        case 2:
            ANT_7.innerHTML = "COPAGO";
            break;
        case 3:
            ANT_7.innerHTML = "CUOTA MODERADORA";
            break;
        case 4:
            ANT_7.innerHTML = "NO APLICA";
            break;
        case 5:
            ANT_7.innerHTML = "PAGOS COMPARTIDOS EN PLANES VOLUNTARIOS DE SALUD";
            break;
        case 6:
            ANT_7.innerHTML = "NO APLICA";
            break;
		case 7:
            ANT_7.innerHTML = "PAGOS COMPARTIDOS EN PLANES VOLUNTARIOS DE SALUD";
            break
		case 8:
            ANT_7.innerHTML = "PAGOS COMPARTIDOS EN PLANES VOLUNTARIOS DE SALUD";
            break
		case 9:
            ANT_7.innerHTML = "NO APLICA";
            break
        default:
            ANT_7.innerHTML = "NO APLICA";
            break;
     }
     ANT.appendChild(ANT_7);

    //concepto recaudo
     var ANT_8 = doc.createElement("ANT_8");

    switch (data.facturado.detallesPagoContrato.regimenContrato) {
        case 1:
            ANT_8.innerHTML = "05";
            break;
        case 2:
            ANT_8.innerHTML = "01";
            break;
        case 3:
            ANT_8.innerHTML = "02";
            break;
        case 4:
            ANT_8.innerHTML = "05";
            break;
        case 5:
            ANT_8.innerHTML = "03";
            break;
        case 6:
            ANT_8.innerHTML = "05";
            break;
		case 7:
            ANT_8.innerHTML = "03";
            break
		case 8:
            ANT_8.innerHTML = "03";
            break
		case 9:
            ANT_8.innerHTML = "05";
            break
        default:
            ANT_8.innerHTML = "05";
			break;
    }
    ANT.appendChild(ANT_8) 

    return ANT;
}

export default ANTTags2;